<template>
  <!-- 雷达图表 -->
  <div :ref="refId" :datas=datas style="width: 100%;height: 100%;"></div>
</template>

// refId                  图表id
// datas                  图表数据源
// transverseData         每个角度的最大值和名称
// colorList              颜色值
// legendList             数值的每个角度占比名称

<script>
export default {
  props: ['refId', 'datas', 'transverseData', 'colorList', 'legendList'],
  data() {
    return {
      pieEcharts: '',
      pieOption: {},
    };
  },
  watch: {
    datas: {
      handler(newValue, oldValue) {
        this.setPieOption(this.refId, newValue, this.transverseData, this.colorList, this.legendList);
      },
      deep: true,
    },
  },
  beforeDestroy() {
    if (this.pieEcharts) {
      this.pieEcharts.clear();
    }
  },
  mounted() {
    if (this.datas.length > 0) {
      this.setPieOption(this.refId, this.datas, this.transverseData, this.colorList, this.legendList);
    }
  },
  methods: {
    isArray(data) { // 判断是否有多个雷达图
      let str1 = 1;
      if (data) {
        for (let i = 0; i < data.length; i++) {
          if (Array.isArray(data[i])) {
            return str1 = 2;
          }
          return str1 = 1;
        }
      }
      return str1;
    },
    setPieOption(refId, datas, transverseData, colorList, legendList) {
      let dataList = [];
      let obj = {};
      if (datas.length) {
        if (this.isArray(datas) == 2) {
          for (let i = 0; i < datas.length; i++) {
            obj = {
              name: legendList[i],
              value: datas[i],
              areaStyle: {
                // 单项区域填充样式
                color: {
                  colorStops: [
                    {
                      offset: 0,
                      color: colorList[i][0],
                    },
                    {
                      offset: 1,
                      color: colorList[i][1],
                    },
                  ],
                  global: false,
                },
                opacity: 1, // 区域透明度
              },
            };
            dataList.push(obj);
          }
        } else {
          obj = {
            name: legendList[0],
            value: datas,
            areaStyle: {
              // 单项区域填充样式
              color: {
                colorStops: [
                  {
                    offset: 0,
                    color: colorList[0][0],
                  },
                  {
                    offset: 1,
                    color: colorList[0][1],
                  },
                ],
                global: false,
              },
              opacity: 1, // 区域透明度
            },
          };
          dataList.push(obj);
        }
      } else {
        obj = {
          name: legendList[0],
          value: datas,
          areaStyle: {
            // 单项区域填充样式
            color: {
              colorStops: [
                {
                  offset: 0,
                  color: colorList[0][0],
                },
                {
                  offset: 1,
                  color: colorList[0][1],
                },
              ],
              global: false,
            },
            opacity: 1, // 区域透明度
          },
        };
      }
      dataList = JSON.stringify(dataList);

      this.pieEcharts = this.$echarts.init(this.$refs[refId]);
      this.pieOption = {
        color: colorList[0][0],
        tooltip: {
          trigger: 'item',
          confine: true, // 浮窗限制在图表内
          backgroundColor: 'rgba(64, 80, 118, 0.8)', // 通过设置rgba调节背景颜色与透明度
          borderColor: 'rgba(64, 80, 118, 0.8)',
          color: '#fff',
          textStyle: {
            color: '#fff',
          },
          axisPointer: {
            type: 'cross',
            label: {
              backgroundColor: '#6a7985',
            },
          },
        },
        radar: [{
          indicator: transverseData, // 每个角度的最大值和文字
          radius: 88,
          center: ['50%', '50%'], // 雷达图的位置
          splitArea: {
            show: true, // 默认显示颜色分割区域，不需要显示
            areaStyle: {
              // 分隔区域的样式设置。
              color: ['#0f173291', '#0f173291', '#0f173291', '#0f173291', '#0f173291'], // 画布颜色 // 分隔区域颜色。分隔区域会按数组中颜色的顺序依次循环设置颜色。默认是一个深浅的间隔色。
            },
          },
          axisName: { // 雷达图边缘文字样式
            color: 'rgba(112, 127, 157, 0.8)',
            fontSize: 13,
          },
          axisLine: {
            show: true, // 是否显示十字交叉线
            // 指向外圈文本的分隔线样式
            lineStyle: {
              color: 'rgba(112, 127, 157, 0.2)', // 线条颜色
            },
          },
          axisLabel: { show: false },
          splitLine: {
            // 雷达一圈圈
            show: true,
            lineStyle: {
              type: 'solid',
              color: 'rgba(112,127,157,0.2)', // 雷达一圈圈颜色分隔线颜色
              width: 1, // 分隔线线宽
            },
          },
        }],
        series: [{
          type: 'radar',
          tooltip: {
            trigger: 'item',
          },
          areaStyle: {},
          data: JSON.parse(dataList),
        }],
      };
      // 渲染图表
      this.pieEcharts.setOption(this.pieOption);
      window.addEventListener('resize', () => {
        this.pieEcharts.resize();
      });
    },
  },
};
</script>

<style scoped>
</style>
